/*
 * @Author: yuszhou@deloitte.com
 * @Date: 2023-01-17 14:54:52
 * @LastEditors: yuszhou@deloitte.com yuszhou@deloitte.com.cn
 * @LastEditTime: 2023-05-08 17:11:23
 * @FilePath: \rc_china_storeportal\src\components\common\Wangeditor\latterSpace.tsx
 * @Description: 给editor添加一个letter-spacing的属性
 */

import { IDomEditor, IOption, ISelectMenu } from '@wangeditor/core'
import { SlateEditor, SlateElement, SlateNode, SlateTransforms } from '@wangeditor/editor'
//spaceing list
const selectOptions: IOption[] = [
  { text: '0.5rem', value: '0.5rem' },
  { text: '1rem', value: '1rem' },
  { text: '1.5rem', value: '1.5rem' },
  { text: '2rem', value: '2rem' },
  { text: '2.5rem', value: '2.5rem' },
  { text: '3rem', value: '3rem' },
  { text: '3.5rem', value: '3.5rem' },
  { text: '4rem', value: '4rem' },
  { text: '4.5rem', value: '4.5rem' },
  { text: '5rem', value: '5rem' },
]
export default class Margin implements ISelectMenu {
  constructor() {
    this.title = 'margin';
    this.tag = 'select'
    this.iconSvg = '<?xml version="1.0" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg t="1675047560747" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2076" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16"><path d="M298.666667 725.333333h426.666666v-55.168a21.333333 21.333333 0 0 1 36.437334-15.061333l94.805333 94.805333a25.6 25.6 0 0 1 0 36.181334l-94.805333 94.805333a21.333333 21.333333 0 0 1-36.437334-15.061333V810.666667H298.666667v55.168a21.333333 21.333333 0 0 1-36.437334 15.061333l-94.805333-94.805333a25.6 25.6 0 0 1 0-36.181334l94.805333-94.805333a21.333333 21.333333 0 0 1 36.437334 15.061333V725.333333z m256-469.333333v341.333333a42.666667 42.666667 0 0 1-85.333334 0V256H256a42.666667 42.666667 0 1 1 0-85.333333h512a42.666667 42.666667 0 0 1 0 85.333333h-213.333333z" fill="#5D6E7F" p-id="2077"></path></svg>'
  }
  selectPanelWidth?: number | undefined;
  title: string;
  iconSvg?: string | undefined;
  hotkey?: string | undefined;
  alwaysEnable?: boolean | undefined;
  tag: string;
  width?: number | undefined;
  getOptions(editor: IDomEditor): IOption[] {
    return selectOptions
  };
  getValue(editor: IDomEditor): string | boolean {
    return editor.getHtml()
  }
  isActive(editor: IDomEditor): boolean {
    return false
  }
  isDisabled(editor: IDomEditor): boolean {
    return false
  }
  exec(editor: IDomEditor, value: string | boolean) {
    if (this.isDisabled(editor)) return
    SlateTransforms.setNodes(editor, {
      // @ts-ignore
      margin: `${value} 0`,
    }, {
      mode: 'highest'
    })
    const nodeEntries = SlateEditor.nodes(editor, {
      match: (node: SlateNode) => {  // TS syntax
        if (SlateElement.isElement(node)) {
          return true
        }
        return false
      },
      universal: true,
    })

    if (nodeEntries == null) {
      // console.log('当前未选中的 paragraph')
    } else {
      for (let nodeEntry of nodeEntries) {
        const [node, path] = nodeEntry
        SlateTransforms.removeNodes(editor)
        // console.log('================there is your node================')
        // console.log(node)
        editor.insertNode(node)
      }
    }
  }
}